import { useModal } from "@commonlibs";
import PayModal from "../PayModal";

export default function useClosePayModal() {
    const { hideModal } = useModal();

    function handleClose() {
        hideModal(PayModal);
    }

    return handleClose;
}
